import { defineMessages } from 'react-intl';

export default defineMessages({
  afterSubmitDescription: {
    id: 'resetPasswordForm.afterSubmitDescription',
    defaultMessage: 'An email with instructions has been sent to {email}',
  },
});
